import { ApplicationType } from '@testsigmainc/constants';
import { AgentService } from '../../../../../../../services/agent.service';

const getSystemOS = (): string => {
  if (window.navigator.userAgent.indexOf('Windows') != -1) {
    return 'windows';
  } else if (window.navigator.userAgent.indexOf('Mac') != -1) {
    return 'mac';
  } else {
    return 'linux';
  }
};

// Cache for base URL to avoid multiple API calls
let cachedDrifterBaseUrl: string | null = null;

const getDrifterVersionsLink = async (): Promise<string> => {
  try {
    // Fetch base URL from server API (only once)
    if (!cachedDrifterBaseUrl) {
      const response = await AgentService.getAgentDownloadUrl();
      cachedDrifterBaseUrl = response.baseUrl;
    }

    return `${cachedDrifterBaseUrl}/testsigmaterminal/manifests/latest.json`;
  } catch (error) {
    console.error('Failed to fetch drifter base URL from server:', error);

    // Fallback to hardcoded URL if API fails
    const defaultHost = 'hybrid-onprem.testsigma.com';
    const hostMap: Record<string, string> = {
      'dev.testsigma.com': 'hybrid-local.testsigma.com',
      'staging.testsigma.com': 'hybrid-staging.testsigma.com',
      'prestaging.testsigma.com': 'hybrid-prestaging.testsigma.com',
      'devtesting.testsigma.com': 'hybrid-devtesting.testsigma.com',
      'blackpearl.testsigma.com': 'hybrid-blackpearl.testsigma.com',
      'vikings.testsigma.com': 'hybrid-vikings.testsigma.com',
      'demons.testsigma.com': 'hybrid-demons.testsigma.com',
      'legends.testsigma.com': 'hybrid-legends.testsigma.com',
      'selenium.testsigma.com': 'hybrid-selenium.testsigma.com',
      'experimental.testsigma.com': 'hybrid-experimental.testsigma.com',
      'app.testsigma.com': 'static-assets.testsigma.com',
      'app-eu.testsigma.com': 'static-assets-eu.testsigma.com',
      'app-in.testsigma.com': 'static-assets-in.testsigma.com',
    };

    const host = window.location.host;
    const domain = Object.keys(hostMap).find((hostName) =>
      host.startsWith(hostName),
    );
    const env = domain ? hostMap[domain] : defaultHost;

    let baseUrl = 's3.amazonaws.com/';
    let s3URL = `https://${baseUrl}${env}/testsigmaterminal/manifests/latest.json`;

    if (
      host.includes('app.testsigma.com') ||
      host.includes('app-eu.testsigma.com') ||
      host.includes('app-in.testsigma.com')
    ) {
      baseUrl = domain ? hostMap[domain] : defaultHost;
      s3URL = `https://${baseUrl}/testsigmaterminal/manifests/latest.json`;
    }

    return s3URL;
  }
};

const isDebuggingWithDrifterSupported = (
  applicationType: ApplicationType,
): boolean => {
  const supportedApplicationTypes = [
    ApplicationType.WebApplication,
    ApplicationType.Salesforce,
    ApplicationType.WINDOWS_ADVANCED,
  ];
  return supportedApplicationTypes.includes(applicationType);
};

export { getSystemOS, isDebuggingWithDrifterSupported, getDrifterVersionsLink };
